import { render, staticRenderFns } from "./CreateInvoice.vue?vue&type=template&id=f53faeca&scoped=true&"
import script from "./CreateInvoice.vue?vue&type=script&lang=js&"
export * from "./CreateInvoice.vue?vue&type=script&lang=js&"
import style0 from "./CreateInvoice.vue?vue&type=style&index=0&id=f53faeca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53faeca",
  null
  
)

export default component.exports